// While a new customer is being registered, looks the typed phone number up
// and reports the existing customer who already has it, so the cashier can
// add that customer instead of creating a duplicate. Read-only: it only runs
// the same customer search the search drawer uses. A failed or offline lookup
// reports nothing; the server's own duplicate rule still applies on save.
import { useEffect, useState } from "react";
import { getCustomer } from "../customer";
import { LAYOUT } from "../../../../utils/fashion/layout";
import { digitsOf, findSamePhone } from "./customerDrawerUi";

const noop = () => {};
export const DUPLICATE_CHECK_DELAY_MS = 400;

export default function useDuplicatePhoneCheck({ enabled, phone, tillData, search = getCustomer, delay = DUPLICATE_CHECK_DELAY_MS }) {
  const [match, setMatch] = useState(null);
  const number = digitsOf(phone).slice(-10);
  const ready = !!enabled && number.length === 10;

  useEffect(() => {
    setMatch(null);
    if (!ready) return undefined;
    if (typeof navigator !== "undefined" && navigator.onLine === false) return undefined;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      let rows;
      try {
        await search(null, LAYOUT.FASHION, number, noop, (r) => (rows = r), null, tillData, null, noop, false, noop, { signal: controller.signal });
      } catch {
        return;
      }
      if (controller.signal.aborted) return;
      setMatch(findSamePhone(rows, number));
    }, delay);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [ready, number]); // eslint-disable-line react-hooks/exhaustive-deps

  return { match: ready ? match : null };
}
